class BcAntenatalRadioTextboxField {
    public Value?: boolean = null;
    public Description: string;
    public Date?: Date;

    constructor(fields?: Partial<BcAntenatalRadioTextboxField>) {
        Object.assign(this, fields);
    }

    public hasSelected(): boolean {
        return this.Value
            || !!this.Description
            || !!this.Date;
    }

    public setDescription(description: string, booleanValue?: boolean): void {
        this.Description = description;
        if (!!description?.trim())
            this.Value = booleanValue ?? this.Value ?? true;
    }

    public setDescriptionAndCheckbox(description: string): void {
        this.Description = description;
        const hasDescription = !!description?.trim();
        if (hasDescription)
            this.Value ||= hasDescription;
    }

    public setDate(date: Date): void {
        this.Date = date;
        if (!!date)
            this.Value ||= true;
    }
}

export { BcAntenatalRadioTextboxField };
